import { useEffect } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Typography, useMediaQuery } from "@mui/material";

// project imports
import { getNavMenuItems } from "../menu-items";
import NavGroup from "./NavGroup";
import useConfig from "@hooks/utils/useConfig";

import LAYOUT_CONST from "constant";
import { HORIZONTAL_MAX_ITEM } from "config";

// types
import { NavItemType } from "types";
import { useProjectContext } from "@hooks/context/useProjectContext";

// ==============================|| SIDEBAR MENU LIST ||============================== //

interface MenuListProps {
  isDrawOpen: boolean;
  selectedItem: string[];
  setSelectedItem: (item: string[]) => void;
  setIsDrawOpen: (isDrawOpen: boolean) => void;
}
const MenuList = ({
  isDrawOpen,
  selectedItem,
  setSelectedItem,
  setIsDrawOpen,
}: MenuListProps) => {
  const theme = useTheme();
  const { layout } = useConfig();
  const { selectedProject, isOwner } = useProjectContext();

  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    handlerMenuItem();
    // eslint-disable-next-line
  }, []);

  // const getMenu = Menu();
  const menuItem = getNavMenuItems(selectedProject.id, isOwner);
  const handlerMenuItem = () => {
    const isFound = menuItem.items.some((element) => {
      if (element.id === "widget") {
        return true;
      }
      return false;
    });

    // if (getMenu?.id !== undefined && !isFound) {
    //   menuItem.items.splice(1, 0, getMenu);
    // }
  };

  // last menu-item to show in horizontal menu bar
  const lastItem =
    layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd
      ? HORIZONTAL_MAX_ITEM
      : null;

  let lastItemIndex = menuItem.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  if (lastItem && lastItem < menuItem.items.length) {
    lastItemId = menuItem.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItem.items
      .slice(lastItem - 1, menuItem.items.length)
      .map((item) => ({
        title: item.title,
        elements: item.children,
      }));
  }

  const navItems = menuItem.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case "group":
        return (
          <NavGroup
            key={item.id}
            item={item}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            isDrawOpen={isDrawOpen}
            setIsDrawOpen={setIsDrawOpen}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
